// extracted by mini-css-extract-plugin
export default {"Button":"main-button_Button__xCHrR","Disabled":"main-button_Disabled__KFOtl"};